import { RouterProvider as UIRouterProvider } from '@sixfold/common-ui';
import * as React from 'react';
import { matchPath, useNavigate, useLocation } from 'react-router';

type RouterProviderProps = {
  children: React.ReactNode;
};

export const RouterProvider = ({ children }: RouterProviderProps) => {
  const navigate = useNavigate();
  const { pathname: locationPathname } = useLocation();

  const getCurrentPropValue = React.useCallback(
    (href: string) => {
      // Discard query string and hash from href for matching.
      const hrefPathname = new URL(href, window.location.origin).pathname;

      // First check for exact match
      const exactMatch = matchPath(
        {
          path: hrefPathname,
          end: true,
        },
        locationPathname,
      );

      if (exactMatch) {
        return 'page';
      }

      // Then check for parent route match (current path starts with href path)
      const parentMatch = matchPath(
        {
          path: hrefPathname,
          end: false, // Allow partial matches for parent routes
        },
        locationPathname,
      );

      if (parentMatch) {
        return true;
      }

      return undefined;
    },
    [locationPathname],
  );

  return (
    <UIRouterProvider navigate={navigate} getCurrentPropValue={getCurrentPropValue}>
      {children}
    </UIRouterProvider>
  );
};
